import React, { useState } from "react";
import ClrDrop1 from "../../images/Colors/blue.png";
import ClrDrop2 from "../../images/Colors/goldenrod.png";
import ClrDrop3 from "../../images/Colors/green.png";
import ClrDrop4 from "../../images/Colors/magenta.png";
import ClrDrop5 from "../../images/Colors/orange.png";
import ClrDrop6 from "../../images/Colors/red.png";
import ClrDrop7 from "../../images/Colors/yellow.png";
import Buttons from "../Buttons";
import { FaShoppingCart } from "react-icons/fa";
import { AiFillSetting, AiOutlineMenuUnfold } from "react-icons/ai";
import "./ColorChange.css";

const ColorChange = () => {
  const [hide, setHide] = useState();
  const colors = [
    "blue",
    "goldenrod",
    "green",
    "magenta",
    "orange",
    "red",
    "yellow",
  ];
  const ChngClrs = [
    {
      id: "id1",
      clr: colors[0],
      title: "blue",
      Dropcolor: ClrDrop1,
      Dropalt: "blue.png",
    },
    {
      id: "id2",
      clr: colors[1],
      title: "goldenrod",
      Dropcolor: ClrDrop2,
      Dropalt: "goldenrod.png",
    },
    {
      id: "id3",
      clr: colors[2],
      title: "green",
      Dropcolor: ClrDrop3,
      Dropalt: "green.png",
    },
    {
      id: "id4",
      clr: colors[3],
      title: "magenta",
      Dropcolor: ClrDrop4,
      Dropalt: "magenta.png",
    },
    {
      id: "id5",
      clr: colors[4],
      title: "orange",
      Dropcolor: ClrDrop5,
      Dropalt: "orange.png",
    },
    {
      id: "id6",
      clr: colors[5],
      title: "red",
      Dropcolor: ClrDrop6,
      Dropalt: "red.png",
    },
    {
      id: "id7",
      clr: colors[6],
      title: "yellow",
      Dropcolor: ClrDrop7,
      Dropalt: "yellow.png",
    },
  ];
  const AppClass = "App";
  const App = document.getElementById(AppClass);
  const ColorHandle = (addOne, addTwo) => {
    App.classList.add(addOne);
    App.classList.remove(colors);
    if ((App.classList = AppClass)) {
      App.classList.add(addTwo);
    }
  };
  return (
    <div className={hide ? "Color_change color_box_slide" : "Color_change"}>
      <div className="toggle" onClick={() => setHide(!hide)}>
        <span className={hide ? "" : "spinner"} title="Change Theme Color">
          {hide ? <AiOutlineMenuUnfold /> : <AiFillSetting />}
        </span>
      </div>
      <div className="color_heading">
        <h3>STYLE SWITCHER</h3>
      </div>
      <div className="colors">
        <ul>
          {ChngClrs.map((clrItems) => (
            <li
              onClick={() => ColorHandle(clrItems.clr, clrItems.clr)}
              title={clrItems.title}
              key={clrItems.id}
            >
              <ColorDrops
                Dropcolor={clrItems.Dropcolor}
                Dropalt={clrItems.Dropalt}
              />
            </li>
          ))}
        </ul>
      </div>
      <div className="section_btns">
        <Buttons btnIcon={<FaShoppingCart />} btntext={"PURCHASE"} />
      </div>
    </div>
  );
};
const ColorDrops = (props) => {
  return (
    <>
      <button>
        <img src={props.Dropcolor} alt={props.Dropalt} />
      </button>
    </>
  );
};
export default ColorChange;
